import React, { useState } from 'react';
import classNames from 'classnames';
import {
  TextButton,
  Dialog,
  TableContent,
  usePreventTableScrollingRef,
  TableContainer,
  CELL_RENDERERS,
  TextRenderer,
} from 'cdk-radial';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import './styles/selectedLocationsDialog.scss';
export default function SelectedLocationsDialog({
  selectedLocationsWithAddresses,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [totalRows, setTotalRows] = useState();

  const componentMainClass = 'selectedLocationsDialog__table';
  const agGridThemeClass = 'ag-theme-balham';
  const tableClass = classNames(componentMainClass, agGridThemeClass);

  const frameworkComponentsExtended = {
    textRenderer: TextRenderer,
  };

  const tableContentRef = usePreventTableScrollingRef();

  const AddressRenderer = (params) => {
    return <div className="address-column-field">{params?.data?.address}</div>;
  };

  const DealershipLocationRenderer = (params) => {
    return (
      <div className="dealership-location-column-field">
        {params?.data?.dealershipLocation}
      </div>
    );
  };

  const columns = [
    {
      cellRendererFramework: DealershipLocationRenderer,
      field: 'dealershipLocation',
      headerName: 'Dealership Location',
      sortable: true,
      resizable: true,
    },
    {
      cellRendererFramework: AddressRenderer,
      field: 'address',
      headerName: 'Address',
      sortable: true,
      resizable: true,
    },
  ];

  const totalSelectedLocations = `${selectedLocationsWithAddresses?.length} Location(s)`;

  const data =
    selectedLocationsWithAddresses &&
    selectedLocationsWithAddresses.map((f) => {
      const fullAddress =
        f.addresses &&
        f.addresses[0] &&
        f.addresses[0].streetAddress + ', ' + f.addresses[0].city;
      return {
        dealershipLocation: f.partyName,
        address: fullAddress,
      };
    });

  const handleGridReady = (gridParams) => {
    setGridApi(gridParams.api);
    setTotalRows(gridParams.api.getDisplayedRowCount());
    gridParams.api.sizeColumnsToFit();
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <TextButton
        text={totalSelectedLocations}
        onClick={handleOpen}
        dataTestId="locations-dialog-button"
        className="locations-button"
      ></TextButton>
      {isOpen && (
        <Dialog
          isOpen={isOpen}
          id="dialog-3"
          className="selected-locations-dialog"
          onClose={handleClose}
          title={`Locations (${selectedLocationsWithAddresses?.length})`}
        >
          <TableContainer
            className={tableClass}
            tableLayout={'normal'}
            hideBorder
          >
            <TableContent data-testid="table-content" ref={tableContentRef}>
              <AgGridReact
                defaultColDef={{
                  filter: false,
                  sortable: true,
                }}
                frameworkComponents={frameworkComponentsExtended}
                columnDefs={columns}
                rowHeight={60}
                onGridReady={handleGridReady}
                rowData={data}
              />
            </TableContent>
          </TableContainer>
        </Dialog>
      )}
    </>
  );
}
